function MediaBusiness(props) {
    return (
        <div className="recruit_contents">
            <div className="recruit_titleline_w">
                <h4 className="recruit_titleline_info">경영</h4>
                <h5 className="recruit_titleline_title">IP 사업</h5>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">직무소개</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">직무 및 필요역량</h7>
                <p className="recruit_subinfo_text">
                    IP사업팀은 콘텐츠 유통 및 IP(Intellectual Property) 사업을 주관하는 부서로 다음과 같은 업무를<br />
                    수행하고 있습니다. 콘텐츠 유통과 관련해서는 국내외 콘텐츠 유통전략 수립 및 실행, 신규사업모델<br />
                    개발, 국내외 OTT플랫폼 관리 등을 맡고 있으며, IP 사업과 관련해서는 IP 사업전략 수립, IP 사업모델<br />
                    다각화, 프로그램 IP 사업권리 확보 및 관리 등을 수행하고 있습니다.<br /><br />

                    IP사업팀은 SBS 콘텐츠의 국내외 유통을 주로 수행하는 부서인 만큼, 다양한 이해관계자를 조율하고<br />
                    업무수행과정에서 발생하는 갈등을 해결하는 역량이 최우선적으로 요구됩니다. 또한, SBS 콘텐츠를<br />
                    이용·소비하는 방법이 다양해짐에 따라 미디어산업 변화에 영향을 주는 IT 관련 트렌드와 진흥·규제<br />
                    정책에 대한 끊임없는 관심 또한 IP사업팀 업무 수행에 반드시 필요한 역량입니다. 직간접적으로<br />
                    연관된 업무 범위가 넓은 만큼, 특정 분야에 국한되기보다는 미디어산업 전반에 걸친 관심과,<br />
                    무엇보다도 콘텐츠 그중에서도 ‘SBS 콘텐츠’에 대한 관심이 가장 중요한 필수 조건이라고 할 수<br />
                    있습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">부서 소개</h7>
                <p className="recruit_subinfo_text">
                    IP사업팀은 제작진이 생산한 콘텐츠를 외부에 유통하고, 콘텐츠를 활용한 새로운 사업모델 개발을<br />
                    수행하는 부서입니다.
                </p>
                <em className="recruit_bold_text">콘텐츠 유통</em>
                <p className="recruit_subinfo_text">
                    유료방송사업자(IPTV, CATV, 위성방송)와 실시간 재송신 및 VOD 공급 계약 조건을 논의하고,<br />
                    방송채널제공사업자(PP)와 콘텐츠 공급에 대한 대가 산정을 협의해서 회사 수익에 기여합니다. 또한,<br />
                    유통 전담 자회사(SBSCH)와의 업무협조를 통해 콘텐츠 유통 및 수출을 관리합니다.
                </p>
                <em className="recruit_bold_text">사업 개발</em>
                <p className="recruit_subinfo_text">
                    외부사업자에게 콘텐츠를 제공하거나 OTT서비스 등을 통한 콘텐츠의 직접적인 공급을 통한 매출<br />
                    확보에서 벗어나, SBS가 보유하고 있는 IP와 아카이브를 기반으로 콘텐츠를 활용한 신규 사업모델을<br />
                    개발해 SBS의 새로운 먹거리를 찾는데 기여합니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">커리어패스 및 비전</h7>
                <p className="recruit_subinfo_text">
                    최근 IT 기술의 발달로 콘텐츠를 이용·소비하는 방법이 다양해짐에 방송사의 전통적인 수익모델인<br />
                    광고산업도 크게 변화하고 있으며, 급기야 실시간 방송(On-air)이라는 말이 어색한 소비자층이 나오는<br />
                    단계까지 이르렀습니다. 이에, 변화하는 콘텐츠 이용·소비패턴에 맞춰 방송사의 수익모델도 변화해야<br />
                    하는 숙제를 안고 있습니다.<br /><br />

                    이러한 미디어생태계 변화에 맞춰, SBS는 콘텐츠 유통 및 IP기반 신규 사업개발에 관한 역량을 갖춘<br />
                    인재를 육성하고 있으며 IP사업팀은 다양한 업무 기회를 통해 콘텐츠 유통 및 신규 사업개발 전문가로<br />
                    성장할 수 있는 경험과 역량을 쌓는데 최적의 부서입니다.
                </p>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">선배인터뷰</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인 소개</h7>
                <p className="recruit_subinfo_text">
                    SBS IP사업팀에서 국내 콘텐츠 유통(재송신/VOD)을 담당하고 있는 윤종세입니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">IP사업팀 중 미디어사업 담당자가 된 계기는?</h7>
                <p className="recruit_subinfo_text">
                입사 후 정책담당 부서에서 근무했었는데, 미디어 시장이 지금보다 복잡하지 않았던 시기에는<br />
                이부서에서 정책대응 및 대관업무와 더불어 미디어사업까지 담당했었습니다. 당시에 저는 정책업무를<br />
                주로 했지만, 직간접적으로 방송사에서 추진했던 초기 미디어사업 관련 업무를 경험할 수 있었고,<br />
                이 과정에서 자연스럽게 미디어사업에 관심을 두게 되었습니다. 이후 방송환경 변화가 심화하고<br />
                유통 방식과 경로가 다원화되면서 방송사 내 별도의 사업조직이 생기게 되었고, 자연스럽게<br />
                미디어사업 업무를 담당하게 되었습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인의 일에서 보람을 느낄 때는?</h7>
                <p className="recruit_subinfo_text">
                    미디어 환경은 끊임없이 변화하고 있는데 방송사가 직접 진행하는 미디어사업의 역사가 길지 않다는<br />
                    것은 미디어사업의 많은 부분이 아직 정형화되지 않았고 지금도 만들어가고 있다는 것을 의미합니다.<br />
                    이것은 우리가 앞으로 만들어 나갈 것도, 할 수 있는 것도, 그리고 해야 할 것도 많다는 것을 뜻합니다.<br />
                    미디어사업은 내가 생각하고 추진하는 일들을 회사의 사업들로 연결할 수 있고, 내가 생각한 그림을<br />
                    현실화시킬 가능성의 공간입니다.<br /><br />

                    개인적으로 미주에서 지상파 3사 콘텐츠를 유통하는 플랫폼인 KCP(현 wavve America)를 기획하고<br />
                    만들고 운영까지 참여해볼 기회가 있었습니다. 제가 적극적으로 참여해서 만든 새로운 회사와<br />
                    서비스가 나날이 성장하고 자리 잡아가는 모습을 보면서 큰 보람을 느낄 수 있었습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">입사지원자에게 해주고 싶은 말</h7>
                <p className="recruit_subinfo_text">
                    사람들은 하루 24시간이라는 제한된 시간 중 많은 부분을 드라마와 예능 등 방송 프로그램을 시청하는<br />
                    데 사용하고 있습니다. 매체가 다양화되고 볼거리와 즐길 거리가 많아진 지금 시점에서도, 방송사가<br />
                    성장하고 글로벌 시청자들의 선택까지 받는 것은 양질의 경쟁력 있는 콘텐츠를 더욱 많은 사람들이<br />
                    손쉽게 접근하고 경험할 수 있기 때문입니다.<br /><br />

                    IP사업팀은 사람들에게 콘텐츠를 시청하는 경로를 열어준다는 점에서 방송사와 시청자를 연결해주는<br />
                    다리와 같은 존재입니다. 그 다리의 주춧돌을 저와 함께 하나씩 놓을 분을 찾고 있습니다. 콘텐츠로<br />
                    하나 되는 세상, 당신이 만들 수 있습니다.
                </p>
            </div>
        </div>);
}

export default MediaBusiness;

